"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cMembershipStateChangeSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
exports.cMembershipStateChangeSchema = zod_1.z.strictObject({
    meta: zod_1.z.optional(zod_1.z.strictObject({
        requester: zod_1.z.number()
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    /** Name of the notification to be sent */
    event: zod_1.z.union([
        zod_1.z.literal(hooks_1.HookName.appliedOnMembership),
        zod_1.z.literal(hooks_1.HookName.acceptedOnMembership),
        zod_1.z.literal(hooks_1.HookName.rejectedOnMembership),
        zod_1.z.literal(hooks_1.HookName.completedOnMembership),
        zod_1.z.literal(hooks_1.HookName.returnedOnMembership),
        zod_1.z.literal(hooks_1.HookName.withdrawnOnMembership),
        zod_1.z.literal(hooks_1.HookName.bannedOnMembership),
    ]),
    /** Name of the notification to be sent; same as `event` */
    action: zod_1.z.union([
        zod_1.z.literal(hooks_1.HookName.appliedOnMembership),
        zod_1.z.literal(hooks_1.HookName.acceptedOnMembership),
        zod_1.z.literal(hooks_1.HookName.rejectedOnMembership),
        zod_1.z.literal(hooks_1.HookName.completedOnMembership),
        zod_1.z.literal(hooks_1.HookName.returnedOnMembership),
        zod_1.z.literal(hooks_1.HookName.withdrawnOnMembership),
        zod_1.z.literal(hooks_1.HookName.bannedOnMembership),
    ]),
    /** ID of the entity which this membership type belongs to */
    entityId: zod_1.z.string().uuid(),
    /** ID of the application the user filled out */
    applicationId: zod_1.z.string().uuid(),
    /** ID of the membership type for which this user's state is changing */
    membershipTypeId: zod_1.z.string().uuid(),
    /** Account ID of the user whose state is being changed */
    receiverAccountId: zod_1.z.number(),
    /** ID of the user list this membership uses to store its members */
    userListId: zod_1.z.string().uuid(),
    /** Custom message to be sent with notification */
    customEmailMessage: zod_1.z.optional(zod_1.z.string()),
    /** Custom template override for email template to be used when accepting a form application */
    emailTemplateOverride: zod_1.z.optional(zod_1.z.string()),
    participants: zod_1.z.optional(zod_1.z.array(zod_1.z.number()))
});
